
import { createSlice } from '@reduxjs/toolkit';
import { getAuthProps, setAuthProps, signOut } from '../../utils/authentication/authLibrary';
import { saveData } from '../../utils/localStorage/LocalStorageHandler';

const authData = getAuthProps();

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: (authData != null),
        user: (authData?.user),
        token: (authData?.token),
        roles: (authData?.roles),
        authData,
        isLoggedIn: (authData?.isAuthenticated),
        userPermissions: (authData?.securityPermissions),
    },

    reducers: {
        authentication: (state, action) => {

            const { message, securityPermissions, ...newAuthProps } = action.payload;

            const { isAuthenticated, roles } = action.payload;
            const userDetails = { ...newAuthProps.user }

            setAuthProps(newAuthProps);

            state.userPermissions = securityPermissions;
            state.isAuthenticated = isAuthenticated;
            state.roles = roles;
            state.user = userDetails;

            state.isLoggedIn = true;
            saveData("SecurityPermission", securityPermissions);
        },
        logout: (state) => {
            state.isLoggedIn = false;
            signOut();
        },
    },
});

export const { authentication, logout } = authSlice.actions;

export default authSlice.reducer;
